import { render, staticRenderFns } from "./ed-icon.vue?vue&type=template&id=5fa5ee2a&scoped=true&"
import script from "./ed-icon.ts?vue&type=script&lang=js&"
export * from "./ed-icon.ts?vue&type=script&lang=js&"
import style0 from "./ed-icon.scss?vue&type=style&index=0&id=5fa5ee2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5ee2a",
  null
  
)

export default component.exports